import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import Page from '../../../page.jsx';
import partnerPropTypes from '../../../partnerPropTypes';

const AgreementRejectedDetails = ({ partner }) => (
    <Page heading="Du har avslått avtalen">
        <div>
            <p>
                Fortell gjerne {partner.name} hvorfor du ikke godkjente avtalen.
                Kanskje dere finner en annen løsning?
            </p>

            <div className="r-phl r-ptl">
                <Link to="/samtale" className="button fullwidth">
                    OK
                </Link>
            </div>
        </div>
    </Page>
);

AgreementRejectedDetails.propTypes = {
    partner: partnerPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        partner: state.partner,
    };
}

export default connect(mapStateToProps)(AgreementRejectedDetails);



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/statusDetails/agreementRejectedDetails.jsx